document.addEventListener('DOMContentLoaded', function () {
  const btn = document.querySelector('#Cart .checkout-button.button');
  if (!btn) return;

  // first disable
  btn.style.pointerEvents = "none";
  btn.style.opacity = "0.5";
  btn.style.cursor = "not-allowed";

  // after 5s enable
  setTimeout(() => {
    btn.style.pointerEvents = "auto";
    btn.style.opacity = "1";
    btn.style.cursor = ""; 
    console.log("Cart drawer enabled");
  }, 3500);

});